import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=2c00d554&scoped=true&"
import script from "./MainSidebar.vue?vue&type=script&lang=ts&"
export * from "./MainSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=2c00d554&prod&lang=scss&"
import style1 from "./MainSidebar.vue?vue&type=style&index=1&id=2c00d554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00d554",
  null
  
)

export default component.exports